module.exports = __webpack_public_path__ + "static/ue_regionalny-4ca4e228be5e3c7c776ef5c7191e38ad.png";